// Generated by purs version 0.14.5
"use strict";
var Box = require("../Box/index.js");
var TacoConstants = require("../TacoConstants/index.js");
var fileUploadContainerStyles = Box.boxStyle([ new Box.Position(Box.Absolute.value), Box.PosLeft.create(new TacoConstants.CustomSize("-9999px")) ]);
module.exports = {
    fileUploadContainerStyles: fileUploadContainerStyles
};
